<!-- BUG-A6 (outside-click dismiss): the full-viewport .modal layer sits ABOVE
     the backdrop (Bootstrap z-index 1055 vs 1050) and intercepts every click
     outside the dialog, so a click handler on the backdrop div itself would
     never fire. Use Bootstrap's own pattern instead: handle the click on the
     .modal element and dismiss only when the click target IS the .modal
     element (i.e. outside .modal-dialog). Escape-to-close is handled by a
     host listener in the component. -->
<div
  class="modal fade"
  tabindex="-1"
  role="dialog"
  [id]="id"
  [ngClass]="{ show: isOpen }"
  [style.display]="isOpen ? 'block' : 'none'"
  (click)="onModalClick($event)">
  <div class="modal-dialog" [ngClass]="sizeClass" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ title }}</h5>
        <button type="button" class="close" (click)="close()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        @if (body) {
          <ng-container [ngTemplateOutlet]="body"></ng-container>
        }
      </div>
      <div class="modal-footer">
        @if (footer) {
          <ng-container [ngTemplateOutlet]="footer"></ng-container>
        }
      </div>
    </div>
  </div>
</div>
<!-- BUG-A6: this modal is hand-toggled (isOpen/display/show classes) rather than
     driven by Bootstrap's JS, so Bootstrap never injects its own `.modal-backdrop`
     element. Without it the page behind the modal stayed fully visible with no
     dimming. Render the backdrop ourselves, reusing Bootstrap's own
     `.modal-backdrop.fade.show` classes/z-index. It is purely visual — the
     dismiss interaction lives on the .modal element above (see note there). -->
@if (isOpen) {
  <div class="modal-backdrop fade show" aria-hidden="true"></div>
}
